/** Rich footer link columns for SEO and navigation. Use `external: true` for static files so the browser fetches them, not the SPA router. */

import {
  industriesMegaMenuColumns,
  megaMenuToFooterLinks,
  navItemsToFooterLinks,
  platformNavItems,
  resourcesNavItems,
  solutionsMegaMenuColumns,
} from "./navMenus";

export type FooterLink = { label: string; href: string; external?: boolean };

export const footerColumns: { title: string; links: FooterLink[] }[] = [
  {
    title: "Platform",
    links: [
      { label: "Features overview", href: "/features" },
      ...navItemsToFooterLinks(platformNavItems),
      { label: "Admin roles FAQ", href: "/faq#admin-roles" },
    ],
  },
  {
    title: "Solutions",
    links: megaMenuToFooterLinks(solutionsMegaMenuColumns),
  },
  {
    title: "Industries",
    links: megaMenuToFooterLinks(industriesMegaMenuColumns),
  },
  {
    title: "Resources",
    links: navItemsToFooterLinks(resourcesNavItems),
  },
  {
    title: "Legal",
    links: [
      { label: "All policies", href: "/legal" },
      { label: "Pricing policy", href: "/legal/pricing-policy" },
      { label: "Privacy policy", href: "/legal/privacy-policy" },
      { label: "Your privacy rights", href: "/legal/privacy-policy#us-residents" },
      { label: "Cookie policy", href: "/legal/cookie-policy" },
      { label: "Terms of service", href: "/legal/terms-of-service" },
      { label: "Disclaimer", href: "/legal/disclaimer" },
      { label: "Refund policy", href: "/legal/refund-policy" },
      { label: "Cancellation policy", href: "/legal/cancellation-policy" },
      { label: "Software license", href: "/legal/software-license-agreement" },
      { label: "Service level agreement", href: "/legal/service-level-agreement" },
    ],
  },
];
